import { createSlice } from '@reduxjs/toolkit';
import { SEARCH_DEFAULT_SORT_BY, SearchState } from 'store/search/types';
import clearSearchFiltersReducer from './reducer/clearSearchFiltersReducer';
import resetSearchReducer from './reducer/resetSearchReducer';
import setCurrentOffsetReducer from './reducer/setCurrentOffsetReducer';
import setCurrentQueryReducer from './reducer/setCurrentQueryReducer';
import setCurrentResultsReducer from './reducer/setCurrentResultsReducer';
import setLastQueryStringHashReducer from './reducer/setLastQueryStringHashReducer';
import setSearchLoadingReducer from './reducer/setSearchLoadingReducer';
import setSearchPageNrReducer from './reducer/setSearchPageNrReducer';
import setSearchParamsReducer from './reducer/setSearchParamsReducer';
import setSearchQueryReducer from './reducer/setSearchQueryReducer';
import setSearchRefetchFlagReducer from './reducer/setSearchRefetchFlagReducer';
import setSearchSortByReducer from './reducer/setSearchSortByReducer';
import setShowFallbackLandingPage from './reducer/setShowFallbackLandingPage';
import setShowSearchFiltersReducer from './reducer/setShowSearchFiltersReducer';
import setTotalResultsAvailableReducer from './reducer/setTotalResultsAvailableReducer';
import setTotalResultsFetchedReducer from './reducer/setTotalResultsFetchedReducer';
import toggleSearchFilterReducer from './reducer/toggleSearchFilterReducer';
import toggleShowSearchFiltersReducer from './reducer/toggleShowSearchFiltersReducer';
import startSearchSessionReducer from './reducer/startSearchSessionReducer';
import setGtmProductsDataReducer from './reducer/setGtmProductsDataReducer';
import setDefaultFiltersReducer from './reducer/setDefaultFiltersReducer';
import setShowRetryModalReducer from './reducer/setShowRetryModalReducer';
import resetFailedSearchRequestReducer from './reducer/resetFailedSearchRequestReducer';
import registerFailedSearchRequestReducer from './reducer/registerFailedSearchRequestReducer';

export const searchInitialState: SearchState = {
  isLoading: true,
  searchQuery: '',
  currentQuery: '',
  parsedQuery: '',
  previewMasks: {
    previewMask: [],
  },
  filters: [],
  results: {
    products: [],
  },
  offset: 99999,
  totalFetched: 0,
  totalAvailable: 0,
  refetchFlag: true,
  showFilters: true,
  showRetryModal: false,
  failedSearchRequestCount: 0,
  settings: {
    sortBy: SEARCH_DEFAULT_SORT_BY,
    filters: {},
    defaultFilters: {},
  },
  lastQueryStringHash: '',
  showFallbackLandingPage: false,
  searchSessionId: '',
  gtmProductsData: {},
};

export const slice = createSlice({
  name: 'search',
  initialState: searchInitialState,
  reducers: {
    setSearchLoadingAction: setSearchLoadingReducer,
    setSearchSortByAction: setSearchSortByReducer,
    setSearchQueryAction: setSearchQueryReducer,
    setCurrentQueryAction: setCurrentQueryReducer,
    setSearchResultsAction: setCurrentResultsReducer,
    setSearchPageNrAction: setSearchPageNrReducer,
    setSearchRefetchFlagAction: setSearchRefetchFlagReducer,
    setCurrentOffsetAction: setCurrentOffsetReducer,
    setTotalResultsAvailableAction: setTotalResultsAvailableReducer,
    setTotalResultsFetchedAction: setTotalResultsFetchedReducer,
    resetSearchAction: resetSearchReducer,
    setSearchParamsAction: setSearchParamsReducer,
    setShowSearchFiltersAction: setShowSearchFiltersReducer,
    toggleShowSearchFiltersAction: toggleShowSearchFiltersReducer,
    toggleSearchFilterAction: toggleSearchFilterReducer,
    setLastQueryStringHashAction: setLastQueryStringHashReducer,
    clearSearchFiltersAction: clearSearchFiltersReducer,
    setShowFallbackLandingPageAction: setShowFallbackLandingPage,
    startSearchSessionAction: startSearchSessionReducer,
    setGtmProductsDataAction: setGtmProductsDataReducer,
    setDefaultFiltersAction: setDefaultFiltersReducer,
    showRetryModalAction: setShowRetryModalReducer,
    registerFailedSearchRequestAction: registerFailedSearchRequestReducer,
    resetFailedSearchRequestAction: resetFailedSearchRequestReducer,
  },
});

export const {
  setSearchLoadingAction,
  setSearchSortByAction,
  setSearchQueryAction,
  setCurrentQueryAction,
  setSearchResultsAction,
  setSearchPageNrAction,
  setSearchRefetchFlagAction,
  setCurrentOffsetAction,
  setTotalResultsAvailableAction,
  setTotalResultsFetchedAction,
  resetSearchAction,
  setSearchParamsAction,
  setShowSearchFiltersAction,
  toggleShowSearchFiltersAction,
  toggleSearchFilterAction,
  setLastQueryStringHashAction,
  clearSearchFiltersAction,
  setShowFallbackLandingPageAction,
  startSearchSessionAction,
  setGtmProductsDataAction,
  setDefaultFiltersAction,
  showRetryModalAction,
  registerFailedSearchRequestAction,
  resetFailedSearchRequestAction,
} = slice.actions;

const search = slice.reducer;
export default search;
